import * as _Odometer from 'odometer';

export const Odometer = _Odometer;
